import React from 'react';
import BarButtonFw, { BUTTON_DEFAULT } from '../../../../../framework/bar-button/BarButtonFw';
import FormGridFw, { FORM_GRID_MODE } from '../../../../../framework/form-grid/FormGridFw';
import { BasePage } from '../../../../../framework/pages/BasePage';
import { COLUMN_DEFAULT, SELECTION_TYPE } from '../../../../../framework/grid/GridFw';
import { MessageUtil } from '../../../../../util/MessageUtil';
import { LoadUtil } from '../../../../../framework/util/LoadUtil';
import { EnvConstants } from '../../../../../EnvConstants';
import { LoadingUtil } from '../../../../../util/LoadingUtil';
import DisabledContext from 'antd/lib/config-provider/DisabledContext';

export class DatosAnalisisModal extends BasePage {

    createPageProperties = (pageApi) => {
        return {
            title: 'Busqueda de Analisis',
            barHeader: {
                fields: [
                    { ...BUTTON_DEFAULT.RETURN, onClick: () => pageApi.hideThisModal() }
                ]
            }
        };
    }

    renderPage(pageApi) {
        const getGridAnalisis = () => pageApi?.getComponent('analisisGrid.grid');
        const getFormAnalisis = () => pageApi?.getComponent('analisisGrid.form');
        
        let descripcion_grupo = '';
        let cantidad_puntos = 1;
        let frecuencia = 1;

        const formGridConfig = {
            mode: FORM_GRID_MODE.FORM_SEARCH,
            form: {
                layout: 'vertical',
                fields: [
                    { type: 'hidden', name: 'id_cotizacion', label: '  ', column: 1, value: pageApi.getParamId(), readOnly: true },
                    { name: 'descripcion', label: 'Descripcion', column: 7, onChange: (value, values) => { descripcion_grupo = value; }, readOnly: Boolean(pageApi.name), value: pageApi.name?.descripcion },
                    {
                        type: 'number', name: 'cantidad', label: 'Cantidad', column: 2, value: pageApi.name?.cantidad || 1, onChange: (value, values) => {
                            cantidad_puntos = value;
                        }
                    },
                    {
                        type: 'number', name: 'frecuencia', label: 'Frecuencia', column: 2, value: 1, onChange: (value, values) => {
                            frecuencia = value;
                        }
                    },
                    {
                        type: 'select', name: 'id_tipo_matriz', label: 'Producto', column: 4, search: true, load: { queryId: 507, fnOk: () => {
                            if (pageApi.name?.id_tipo_matriz) {
                                getFormAnalisis().setData({
                                    ...getFormAnalisis().getData(),
                                    id_tipo_matriz: parseInt(pageApi.name?.id_tipo_matriz)
                                });
                            }
                        }},
                        allowClear: true, readOnly: Boolean(pageApi.name),
                    },
                    {
                        type: "select", name: "id_matriz", label: "Matriz", column: 4, load: { queryId: 816, fnOk: () => {
                            if (pageApi.name?.id_matriz) {
                                getFormAnalisis().setData({
                                    ...getFormAnalisis().getData(),
                                    id_matriz: parseInt(pageApi.name?.id_matriz)
                                });
                            }
                        }}, search: true,
                        readOnly: Boolean(pageApi.name),
                        parents: [
                            { name: "id_tipo_matriz", paramName: "id_tipo_matriz", required: true },
                            { name: "id_cotizacion", paramName: "id_cotizacion" },
                        ],
                    },
                    {
                        type: "select", name: "id_ana", label: "Analisis", multiple: true, editable: true, multipleInString: true,
                        // readOnly: Boolean(pageApi.name),
                        column: 4, load: { queryId: 830 }, search: true,
                        parents: [
                            { name: "id_matriz", paramName: "id_matriz", required: true },
                            { name: "id_cotizacion", paramName: "id_cotizacion" },
                        ],

                    },
                ]
            },
            grid: {
                rowId: 'codigo',
                showIndex: false,
                autoLoad: false,
                pagination: {
                    server: false,
                    showSizeChanger: true
                },
                filter: true,
                load: {
                    queryId: 831,
                    params: {
                        id_moneda: 1, id_doc: pageApi.getParamId()
                    },
                    hideMessage: true,
                    hideMessageError: true
                },
                fields: [
                    { name: 'analisis', label: 'Parámetro', fnTooltip: (_, row) => row.observaciones },
                    { name: 'acreditador', label: 'Acreditado' },
                    { name: 'sub_total_text', label: 'Precio' },
                    {
                        type: 'select', name: 'parametros', maxVisible: 2, label: 'Sub Parámetros', labelName: 'parametrosDes', search: true, multipleInString: true,
                        load: {
                            queryId: 305,
                            params: () => {
                                return { id_rel_metodo_matriz: getGridAnalisis()?.itemEditing?.id_rel_metodo_matriz || 0 }
                            }
                        },
                        multiple: true, editable: true,
                        onChange: (value, row, getApi) => {
                            getGridAnalisis().refresh();
                        }
                    },
                    {
                        ...COLUMN_DEFAULT.ADD_SQUARE, color: 'green', title: 'Seleccionar', label: 'Opciones', width: 100, onClick: async (value, row) => {

                            await getGridAnalisis().saveItemEditing();
                            getGridAnalisis().refresh();
                            let analisis = row;
                            if (descripcion_grupo != '') {

                                if (analisis) {
                                    let sub_total = parseFloat(cantidad_puntos * frecuencia * analisis.precio_venta).toFixed(2);

                                    let obj_analisis = {
                                        ...analisis,
                                        id_matriz_evaluacion: analisis.id_matriz,
                                        matriz_evaluacion: analisis.nombre_matriz,
                                        mat_nombre: analisis.nombre_matriz,
                                        inacal: analisis.acreditador,
                                        parametro: analisis.analisis,
                                        descripcion_grupo,
                                        producto_matriz: analisis.producto_matriz,
                                        cantidad_puntos,
                                        frecuencia,
                                        sub_total,
                                        simb_moneda: analisis.simb_moneda,
                                    }
                                    if (obj_analisis.parametros == "") {
                                        if (analisis.compuesto == 0) {
                                            return MessageUtil('warning', 'Alerta!', 'Debe seleccionar por lo menos un Sub parámetro para el Análisis!');
                                        }
                                    }
                                    pageApi.getEvent('afterAddEvent')(obj_analisis);
                                    // LoadingUtil.loadShow();
                                    // LoadUtil.loadByQueryId({
                                    //     url: EnvConstants.GET_FW_FORM_URL_LIST_BASE(),
                                    //     queryId: 844,
                                    //     params: {
                                    //         parametros: analisis.parametros
                                    //     },
                                    //     fnOk: (res) => {
                                    //         if(!res?.error) {

                                    //         } else {
                                    //             MessageUtil("error", res.message, "");
                                    //         }
                                    //         LoadingUtil.loadHide();  
                                    //     }
                                    // })

                                }
                                else {
                                    return MessageUtil('warning', 'Alerta!', 'Debe seleccionar por lo menos un Análisis!');
                                }
                            }
                            else {
                                return MessageUtil('warning', 'Alerta!', 'Descripción es campo obligatorio!');
                            }
                        }
                    }
                ],
            }
            // bar: barHeaderConfig
        };

        return (
            <>
                <FormGridFw
                    name="analisisGrid"
                    getParentApi={pageApi.getApi}
                    config={formGridConfig}
                />


            </>
        )

    }

}